export default "__VITE_ASSET__C$Pfa3Q6__"